import { useCallback } from 'react';

import { Selector } from '../entity';

import {
  useChannelLinkMany,
  ChannelLinkManyData,
  useSiteLinkMany,
  SiteLinkManyData,
} from './query';
import { SnakeIdObj } from '@synapex/tools/typescript';

type Filter = { filter: boolean };

export const useChannelLinksByGroup = ({
  channel_links_group_id,
  channel_id,
  filter,
}: SnakeIdObj<'channel_links_group' | 'channel'> & Filter) => {
  const select = useCallback(
    (data: ChannelLinkManyData) =>
      filter
        ? Selector.channelLinksByGroup({ channel_links_group_id }, data)
        : data,
    [channel_links_group_id, filter],
  );

  return useChannelLinkMany(
    { channel_id },
    {
      select,
    },
  );
};

export const useSiteLinksByGroup = ({
  site_links_group_id,
  site_id,
  filter,
}: SnakeIdObj<'site_links_group' | 'site'> & Filter) => {
  const select = useCallback(
    (data: SiteLinkManyData) =>
      filter ? Selector.siteLinksByGroup({ site_links_group_id }, data) : data,
    [site_links_group_id, filter],
  );

  return useSiteLinkMany(
    { site_id },
    {
      select,
    },
  );
};
